import type { CmtsHttpClient } from "../api/cmtsHttpClient.js";
import type { CmtsQuery } from "../view-models/complaintViewModels.js";
import { repositoryCall, type RepositoryResult } from "./repositoryResult.js";
import { mapCollection } from "./repositoryCollection.js";

export function toQueryParams(query?: CmtsQuery): Record<string, string | number | boolean | undefined> {
  return { tenantId: query?.tenantId, searchText: query?.searchText, pageNumber: query?.pageNumber, pageSize: query?.pageSize, sortBy: query?.sortBy, sortDirection: query?.sortDirection, ...(query?.filters ?? {}) };
}

export type EntityRepository<TVm, TCreate = Record<string, unknown>, TUpdate = Partial<TCreate>> = {
  list(query?: CmtsQuery): Promise<RepositoryResult<readonly TVm[]>>;
  get(id: string, query?: CmtsQuery): Promise<RepositoryResult<TVm | null>>;
  create(payload: TCreate): Promise<RepositoryResult<TVm>>;
  update(id: string, payload: TUpdate): Promise<RepositoryResult<TVm>>;
};

export function createEntityRepository<TVm, TCreate = Record<string, unknown>, TUpdate = Partial<TCreate>>(client: CmtsHttpClient, cfg: { listPath: string; detailPath: (id: string) => string; createPath?: string | undefined; mapper: (dto: unknown) => TVm; contextCode: string; }): EntityRepository<TVm, TCreate, TUpdate> {
  return {
    list: (query) => repositoryCall(async () => mapCollection(await client.get<unknown>(cfg.listPath, { query: toQueryParams(query) }), cfg.mapper), `${cfg.contextCode}_LIST`),
    get: (id, query) => repositoryCall(async () => { const data = await client.get<unknown>(cfg.detailPath(id), { query: toQueryParams(query) }); return data ? cfg.mapper(data) : null; }, `${cfg.contextCode}_GET`),
    create: (payload) => repositoryCall(async () => cfg.mapper(await client.post<unknown>(cfg.createPath ?? cfg.listPath, payload)), `${cfg.contextCode}_CREATE`),
    update: (id, payload) => repositoryCall(async () => cfg.mapper(await client.put<unknown>(cfg.detailPath(id), payload)), `${cfg.contextCode}_UPDATE`),
  };
}
